import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface CostRecordItem {
  date: string;
  costType: string;
  amount: number | null;
  source: string;
  flux: string;
  campaignId?: number;
  campaignName?: string;
  campaignCode?: string;
}

export interface LifeTimeValueDTO {
  totalSale: number | null;
  totalAcquisition: number | null;
  periodStart: string;
  periodEnd: string;
  records: CostRecordItem[];
}

@Injectable({
  providedIn: 'root'
})
export class EngineLtvService {

  private readonly resourceUrl = environment.SERVER_API_URL + 'services/engine/api/ltv';

  constructor(private http: HttpClient) {}

  getForPersonal(tenant: string, personalId: number, partner?: string): Observable<LifeTimeValueDTO> {
    const url = `${this.resourceUrl}/personal/${personalId}`;
    let headers = new HttpHeaders().set('X-DataStoreID', tenant);
    if (partner) {
      headers = headers.set('X-PARTNER-ID', partner);
    }
    return this.http.get<LifeTimeValueDTO>(url, { headers });
  }

  getForCommand(tenant: string, commandId: number, partner?: string): Observable<LifeTimeValueDTO> {
    const url = `${this.resourceUrl}/command/${commandId}`;
    let headers = new HttpHeaders().set('X-DataStoreID', tenant);
    if (partner) {
      headers = headers.set('X-PARTNER-ID', partner);
    }
    return this.http.get<LifeTimeValueDTO>(url, { headers });
  }
}
